import {Frame as FrameOrigin} from "brigada/src/widget/Frame.js";
import {LayoutUpdate} from "base/assets/js/widget/LayoutUpdate.js";
import {Layers} from "base/assets/js/widget/Layers.js";
import {LayoutScroll} from "base/assets/js/widget/LayoutScroll.js";
import {LoadBar} from "base/assets/js/widget/LoadBar.js";
import {BodyMode} from "base/assets/js/widget/BodyMode.js";
import {Query} from "base/assets/js/widget/Query.js";
/**
 * свой Frame
 */
export class Frame extends FrameOrigin {

	sYmCounter = '27358862';
	sGaCounter = 'UA-3108232-14';

	_oLayers;
	_oLayoutScroll;
	_oLoadBar;
	_bMain;

	toState( iStateId ) {

		// чтобы не вываливалась шапка, при переходах
		this._getLayoutScroll().disable( true );

		const bRet = super.toState( iStateId );
		if( bRet ) {
			// нужно обновить макет, потому что как минимум
			// на разных страницах разные body css классы могут быть
			const oLayoutUpdate = this._rel().typeOf( LayoutUpdate ).find();
			oLayoutUpdate.run();

			setTimeout( () => {
				this._getLayoutScroll().state( false );
				this._getLayoutScroll().disable( false );
			}, 200 )
		}
		return bRet;
	}

	update( ...aArgs ) {

		// просто закроем все слои
		if( typeof this._bMain === 'undefined' ) {
			this._bMain = this.getFrameId() === 'main';
		}
		let sReferrer;
		if( this._bMain ) {

			// чтобы не вываливалась шапка, при переходах
			this._getLayoutScroll().state( true );
			this._getLayoutScroll().disable( true );

			// сброс режима
			const oBodyMode = this._getBodyMode();
			oBodyMode.setMode( 'body_searchbar', false );
			oBodyMode.setMode( 'body_userbar', false );
			if( oBodyMode.isShowOverlay() ) {
				oBodyMode.setMode( 'body_leftbar', false );
			}
			if( oBodyMode.isShowOverlay() ) {
				oBodyMode.setMode( 'body_pulse', false );
			}

			this._getLoadBar().start();

			this._getLayers().hide( { sFrameId: "" } );

			sReferrer = this.url();
		}
		return super.update( ...aArgs ).then( ( mRet ) => {
			if( this._bMain ) {

				// полосочка индикации загрузки страницы
				this._getLoadBar().end();

				// выплявающия плашка шапки
				setTimeout( () => {
					this._getLayoutScroll().state( false );
					this._getLayoutScroll().disable( false );
				}, 200 );

				// яндекс метрика
				if( typeof ym !== 'undefined' ) {
					ym(
						this.sYmCounter,
						'hit',
						this.url(),
						{
							referer: sReferrer
						}
					);
				}
				// гугл аналитика
				if( typeof ga !== 'undefined' ) {
					ga(
						'send',
						{
							hitType: 'pageview',
							page: location.pathname
						}
					);
				}

				// Query зависят от того есть ли на странице фильтр, надо их сбрасывать
				this._rel()
					.typeOf( Query )
					.canEmpty()
					.find( true )
					.forEach( ( oQuery ) =>	{
						oQuery.reset();
					} );

			}
			return mRet;
		} );
	}

	/*_onStateChange( ...aArgs ) {
		if( this._bMain && this._oXhr.readyState === 3 ) {
			this._getLoadBar().progress();
		}
		return super._onStateChange( ...aArgs );
	}*/

	_scroll( oOpts, sHash ) {
		if( sHash === 'comments-new' ) {
			// найдем первый активный комментарий
			let eAnchor = document.querySelector( '.comm_active' );
			if( eAnchor ) {
				eAnchor.scrollIntoView();
				return;
			}
			// не нашли активный, просто к комментам перекидываем
			sHash = 'comments';
		}
		return super._scroll( oOpts, sHash );
	}

	/**
	 * @return {Layers}
	 */
	_getLayers() {
		if( !this._oLayers ) {
			this._oLayers = this._rel().typeOf( Layers ).find()
		}
		return this._oLayers;
	}

	/**
	 * @return {LayoutScroll}
	 */
	_getLayoutScroll() {
		if( !this._oLayoutScroll ) {
			this._oLayoutScroll = this._rel().typeOf( LayoutScroll ).find()
		}
		return this._oLayoutScroll;
	}

	/**
	 * @return {LoadBar}
	 */
	_getLoadBar() {
		if( !this._oLoadBar ) {
			this._oLoadBar = this._rel().typeOf( LoadBar ).find()
		}
		return this._oLoadBar;
	}

	/**
	 * @return {BodyMode}
	 */
	_getBodyMode() {
		if( !this._oBodyMode ) {
			this._oBodyMode = this._rel()
				.typeOf( BodyMode )
				.find();
		}
		return this._oBodyMode;
	}
}